/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { File } from '../models/File';
import type { UpdateFile } from '../models/UpdateFile';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FileService {
    /**
     * Loading files
     * Load file from your devices
     * @param filename The sourse filename from device
     * @param requestBody Load one file from device
     * @returns File OK
     * @throws ApiError
     */
    public static loadFile(
        filename: string,
        requestBody?: Blob,
    ): CancelablePromise<File> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/file/load/{filename}',
            path: {
                'filename': filename,
            },
            body: requestBody,
            mediaType: 'application/octet-stream',
        });
    }
    /**
     * Files list
     * Show files list
     * @returns any OK
     * @throws ApiError
     */
    public static fileList(): CancelablePromise<{
        items?: Array<File>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/file/list',
        });
    }
    /**
     * Edit file data
     * We allow to edit only description and state
     * @param id
     * @param requestBody Edit file data
     * @returns File OK
     * @throws ApiError
     */
    public static editFile(
        id: string,
        requestBody?: UpdateFile,
    ): CancelablePromise<File> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/file/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
